<template>
  <div class="page-container">
    <a-spin :spinning="pageLoading" size="large" tip="Loading...">
      <internal-header
        :data="headApiItems"
        @onPickFreq="pickFreqShow"
        @onTimeDelivery="timeDeliveryShow"
      ></internal-header>
      <andon-content
        class="spv-content"
        :kit-status-items="kitStatusItems"
        :andon-type-items="andonTypeItems"
        :fifo-stock-items="fifoStockItems"
        :fifo-refresh-interval="config.fifoRefreshInterval"
        :summary-type="config.summaryType"
        @onPreviousClick="previousClick"
        @onNextClick="nextClick"
        @colClick="showCategoryDetailModal"
        @showAndonSummary="showAndonSummary"
        @onKitStatusShow="kitStatusShow"
        @onFifoStockShow="fifoStockShow"
      ></andon-content>
    </a-spin>
    <div class="footer-placeholder"></div>
    <a-modal
      v-model:visible="detailModal.visible"
      :title="detailModal.title"
      width="80%"
      wrap-class-name="has-table-full-modal"
      @cancel="onModalCancel"
    >
      <template #footer>
        <a-button
          @click="modalRefresh"
          v-if="[1, 2].includes(detailModal.currentType)"
          :loading="refreshBtnLoading"
        >
          <template #icon>
            <undo-outlined />
          </template>
          Refresh
        </a-button>
        <a-button type="primary" @click="onModalCancel">
          <template #icon>
            <close-outlined />
          </template>
          Close
        </a-button>
      </template>
      <category-table
        :is-open="detailModal.visible"
        :current-params="currentParams"
        v-if="detailModal.currentType === 1"
        ref="andonCategoryTable"
      ></category-table>
      <summary-table
        :current-params="currentParams"
        :is-open="detailModal.visible"
        ref="andonSummaryTable"
        v-if="detailModal.currentType === 2"
      ></summary-table>
      <pick-freq-detail
        v-if="detailModal.currentType === 3"
        :data="currentPickFreqItems"
      ></pick-freq-detail>
      <time-delivery-detail
        v-if="detailModal.currentType === 4"
        :data="currentonTimeDeliveryItems"
      ></time-delivery-detail>
      <kit-status-detail
        v-if="detailModal.currentType === 5"
        :data="currentKitStatusItems"
      ></kit-status-detail>
      <fifo-stock-detail
        v-if="detailModal.currentType === 6"
        :data="currentFifoStockItems"
      ></fifo-stock-detail>
    </a-modal>
  </div>
</template>
<script setup>
  import InternalHeader from './internal-header'
  import andonContent from './andon-content'
  import categoryTable from './category-table.vue'
  import summaryTable from './summary-table.vue'
  import pickFreqDetail from './pick-freq-detail.vue'
  import timeDeliveryDetail from './time-delivery-detail.vue'
  import kitStatusDetail from './kit-status-detail.vue'
  import fifoStockDetail from './fifo-stock-detail.vue'
  import { CloseOutlined, UndoOutlined } from '@ant-design/icons-vue'

  import { reactive, ref, onUnmounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'
  import request from '@/utils/request'
  import { message } from 'ant-design-vue'
  const store = useStore()
  const route = useRoute()
  const branch = computed(() => store.getters['user/currentSystem'])

  const currentUiPageId = ref('')
  const pageLoading = ref(false)
  const pageRefreshTimer = ref(null)
  const autoPageTimeOut = ref(null)
  const andonTypeItems = ref([])
  const kitStatusItems = ref([])
  const headApiItems = ref([])
  const fifoStockItems = ref([])

  const config = reactive({
    isAutoScroll: true,
    autoScrollInterval: 30000,
    pageRefreshInterval: 30000,
    fifoRefreshInterval: 30000,
    summaryType: '',
  })
  const detailModal = reactive({
    visible: false,
    currentType: 1,
    title: '',
  })
  // 组件卸载时
  onUnmounted(() => {
    clearTimeout(pageRefreshTimer.value)
    clearTimeout(autoPageTimeOut.value)
  })
  const getPageData = (url, loading) => {
    clearTimeout(pageRefreshTimer.value)
    clearTimeout(autoPageTimeOut.value)
    pageLoading.value = Boolean(loading)
    request({
      url,
      params: {
        uiPageId: currentUiPageId.value || route.query.id,
      },
    })
      .then((res) => {
        sortItems(res.body)
        const { isAutoScroll, autoScrollInterval } = res.body.pageCtrlMaster
        const { pageRefreshInterval, summaryType } = res.body.cfgPageCtrlIl
        currentUiPageId.value = res.body.uiPageId
        config.isAutoScroll = isAutoScroll
        config.autoScrollInterval = autoScrollInterval
        config.pageRefreshInterval = pageRefreshInterval
        config.fifoRefreshInterval =
          res.body.pageHeaderView.pageHeaderColumns[0].cfgPageIlHeader.fifoRefreshInterval
        config.summaryType = summaryType
      })
      .finally(() => {
        pageLoading.value = false
        if (config.autoScrollInterval > config.pageRefreshInterval) {
          pageRefreshTimer.value = setTimeout(() => {
            getPageData('/api/ild/getPageView', false)
          }, config.pageRefreshInterval)
        }

        if (config.isAutoScroll) {
          autoPageTimeOut.value = setTimeout(() => {
            getPageData('/api/ild/getNextPageView', false)
          }, config.autoScrollInterval)
        }
      })
  }
  const sortItems = (data) => {
    let tArr = data.pageHeaderView.pageHeaderColumns.map(
      (item) => item.cfgPageIlHeader.columSortId
    )
    let m = tArr.slice()
    let n = m.sort()
    let t = n.map((list) => tArr.indexOf(list))
    andonTypeItems.value = data.pageAndoView.pageAndonRows
    headApiItems.value = data.pageHeaderView.pageHeaderColumns.sort(
      compare('cfgPageIlHeader', 'columSortId')
    )

    let andonRows = data.pageAndoView.pageAndonRows
    andonRows.forEach((list, index) => {
      let newArr = []
      t.forEach((li) => {
        newArr.push(list.pageAndonColumns[li])
      })
      andonTypeItems.value[index].pageAndonColumns = newArr
    })

    let kitStatuses = data.pageKitStatusView.pageKitStatuses
    let kitStatusesSortArr = []
    t.forEach((li) => {
      kitStatusesSortArr.push(kitStatuses[li])
    })
    kitStatusItems.value = kitStatusesSortArr

    let fifoStockColumns = data.pageFifoStockView.pageFifoStockColumns
    let fifoStockColumnsArr = []
    t.forEach((li) => {
      fifoStockColumnsArr.push(fifoStockColumns[li])
    })
    fifoStockItems.value = fifoStockColumnsArr
  }
  const compare = (prop, prop2) => {
    return function (obj1, obj2) {
      var val1 = obj1[prop][prop2]
      var val2 = obj2[prop][prop2]
      if (val1 < val2) {
        return -1
      } else if (val1 > val2) {
        return 1
      } else {
        return 0
      }
    }
  }
  const previousClick = () => {
    getPageData('/api/ild/getPreviousPageView', true)
  }
  const nextClick = () => {
    getPageData('/api/ild/getNextPageView', true)
  }
  //进入页面执行函数
  getPageData('/api/ild/getPageView', true)
  // 弹层
  const currentParams = ref({})
  const showCategoryDetailModal = (item) => {
    currentParams.value = { ...item, uiPageId: currentUiPageId.value }
    detailModal.currentType = 1
    detailModal.visible = true
    detailModal.title = item.colunmnName + ' Andon Details'
    clearTimeout(pageRefreshTimer.value)
    clearTimeout(autoPageTimeOut.value)
  }
  const showAndonSummary = (item) => {
    currentParams.value = {
      cShowName: item.andonCshowName,
      uiPageId: currentUiPageId.value,
    }
    detailModal.currentType = 2
    detailModal.visible = true
    detailModal.title = `GEHC ${
      branch.value * 1 === 0 ? 'BJ' : 'TJ'
    } Plant Andon Summary`
    clearTimeout(pageRefreshTimer.value)
    clearTimeout(autoPageTimeOut.value)
  }
  const currentPickFreqItems = ref([])
  const pickFreqShow = (item) => {
    if (
      item.cfgPageIlKpiColumns.length == 0 ||
      item.cfgPageIlKpiColumns[0].kpiFrequescyRecords.length == 0
    ) {
      message.warning('暂无数据')
    } else {
      currentPickFreqItems.value =
        item.cfgPageIlKpiColumns[0].kpiFrequescyRecords
      detailModal.currentType = 3
      detailModal.visible = true
      detailModal.title = item.cfgPageIlHeader.columName + ' Pick Frequency'
      clearTimeout(pageRefreshTimer.value)
      clearTimeout(autoPageTimeOut.value)
    }
  }
  const currentonTimeDeliveryItems = ref([])
  const timeDeliveryShow = (item) => {
    if (
      item.cfgPageIlKpiColumns.length == 0 ||
      item.cfgPageIlKpiColumns[1].pickRequests.length == 0
    ) {
      message.warning('暂无数据')
    } else {
      currentonTimeDeliveryItems.value =
        item.cfgPageIlKpiColumns[1].pickRequests
      detailModal.currentType = 4
      detailModal.visible = true
      detailModal.title = item.cfgPageIlHeader.columName + ' On-Time Delivery'
      clearTimeout(pageRefreshTimer.value)
      clearTimeout(autoPageTimeOut.value)
    }
  }
  const currentKitStatusItems = ref([])
  const kitStatusShow = (item) => {
    if (item.kitPreparationStauses.length == 0) {
      message.warning('暂无数据')
    } else {
      currentKitStatusItems.value = item.kitPreparationStauses
      detailModal.currentType = 5
      detailModal.visible = true
      detailModal.title =
        item.cfgPageIlPace.columnName + ' Kit Preparation Status'
      clearTimeout(pageRefreshTimer.value)
      clearTimeout(autoPageTimeOut.value)
    }
  }
  const currentFifoStockItems = ref([])
  const fifoStockShow = (item) => {
    if (item.matFifoCombinedBeans.length == 0) {
      message.warning('暂无数据')
    } else {
      currentFifoStockItems.value = item.matFifoCombinedBeans
      detailModal.currentType = 6
      detailModal.visible = true
      detailModal.title = item.columnName + ' FIFO Coverage'
      clearTimeout(pageRefreshTimer.value)
      clearTimeout(autoPageTimeOut.value)
    }
  }

  const refreshBtnLoading = ref(false)
  const andonCategoryTable = ref(null)
  const andonSummaryTable = ref(null)
  const modalRefresh = async () => {
    refreshBtnLoading.value = true
    try {
      if (detailModal.currentType === 1) {
        andonCategoryTable.value.refresh()
      } else if (detailModal.currentType === 2) {
        andonSummaryTable.value.refresh()
      }

      refreshBtnLoading.value = false
    } catch (e) {
      refreshBtnLoading.value = false
    }
  }
  const onModalCancel = () => {
    detailModal.visible = false
    getPageData('api/ild/getPageView', false)
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .page-container {
    font-family: GEInspira-Medium, 'GE Inspira Medium';
    height: calc(100vh - 32px);
  }
  .footer-placeholder {
    height: 10px;
    background: @subMaster;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
<style lang="less">
  .has-table-full-modal {
    .ant-modal-body {
      padding: 0;
    }
  }
</style>
